import BulletPointsCard from '../BulletPointsCard'
import Call from '../../Icons/coaching/call.svg'
import System from '../../Icons/coaching/system.svg'
import CallClock from '../../Icons/coaching/call-clock.svg'

const bulletPoints = [
    {
        title: 'Call tracking software:',
        description:
            'Harnessing advanced call tracking technology, we gain invaluable insights into campaign performance, allowing us to refine strategies in real-time for maximum impact.',
        icon: Call,
    },
    {
        title: 'System integration (OLC)',
        description:
            'Our seamless integration ensures that every aspect of your open letter campaign operates effortlessly within your existing systems, optimizing efficiency and effectiveness.',
        icon: System,
    },
    {
        title: 'CRM setup',
        description:
            'Elevating customer relationships is  our priority. Our CRM setup enables personalized interactions, fostering lasting connections and driving sustained growth.',
        icon: CallClock,
    },
]

function Technology({ props }) {
    return (
        <BulletPointsCard
            {...props}
            title="Technology Enhancements"
            bulletPoints={bulletPoints}
            imagePath="/assets/coaching/4.png"
            imageAlt="A close-up of two businesspeople reviewing documents on a tablet, with one hand holding a pen and pointing."
            imageTitle="Business professionals discussing data on a tablet."
            mobileImagePath={'/assets/coaching/4-mobile.png'}
        />
    )
}

export default Technology
